import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy redirect — /concepts/$id/expand was renamed to /concepts/$id/curate
 * as part of the JourneyBar retirement (2026-05-27). Forwards params AND search
 * so deep-links with ?selectedPaperId=…, ?scope=…, filter state, etc. survive.
 *
 * The curate route uses the same search schema this file used pre-rename, so
 * pass-through is type-safe; cast to bypass the legacy route's own schema typing.
 */
export const Route = createFileRoute("/concepts/$conceptId/expand")({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/concepts/$conceptId/curate",
      params: { conceptId: params.conceptId },
      search: search as never,
      replace: true,
    });
  },
});
